module.exports = __webpack_public_path__ + "static/img/IR story.52feb038.svg";